import $ from 'jquery';
import 'slick-carousel';

export default function rlxSliderWatchCover() {
    const $sliderWatchCover = $('.js-rlx-v7-watch-cover__slide');
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    const initSlider = () => {
        if (!$sliderWatchCover.hasClass('slick-initialized')) {
            $sliderWatchCover.slick({
                infinite: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: false,
                prevArrow: false,
            });
        }
    };

    const destroySlider = () => {
        if ($sliderWatchCover.hasClass('slick-initialized')) {
            $sliderWatchCover.slick('unslick');
        }
    };

    const checkSlider = () => {
        if (mobileQuery.matches) {
            initSlider();
        } else {
            destroySlider();
        }
    };

    checkSlider();
    mobileQuery.addListener(checkSlider);
}
